import { z } from "zod";

export const bettingCompetitor = z.object({
  abbreviation: z.string().nullish(),
  iconUri: z.string().nullish(),
  name: z.string(),
  nationality: z.string().nullish(),
  type: z.enum(["PLAYER", "FRANCHISE", "RACER", "FLAG"]),
  number: z.number().optional(),
  silksUrl: z.string().optional(),
  scratched: z.boolean().optional(),
});

export type BettingCompetitor = z.infer<typeof bettingCompetitor>;
